import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type DeleteCollectionNoteRequest = {
  id: number;
};

export type DeleteCollectionNoteResponse = {};

export const deleteCollectionNote = async (request: DeleteCollectionNoteRequest) => {
  const response = await executeApiRequest(
    () => axios.delete<DeleteCollectionNoteResponse>(`/notes`, { params: request }),
    false
  );

  return response?.data;
};
